(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector('input[name="country_code"], input[name="locale_code"]'),
      button: this.querySelector('button'),
      panel: this.querySelector('.disclosure__list-wrapper'),
    };

    // Apply saved currency immediately to prevent flash
    this.applySavedCurrencyEarly();

    this.elements.button.addEventListener('click', this.openSelector.bind(this));
    this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
    this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

    this.querySelectorAll('a').forEach(item =>
      item.addEventListener('click', this.onItemClick.bind(this))
    );

    // Apply saved currency after reload
    this.applySavedCurrency();

    // Update button text (fallback)
    this.updateButtonTextOnLoad();
  }

  // --- PANEL CONTROLS ---
  hidePanel() {
    this.elements.button.setAttribute('aria-expanded', 'false');
    this.elements.panel.setAttribute('hidden', true);
  }

  onContainerKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;
    this.hidePanel();
    this.elements.button.focus();
  }

  openSelector() {
    this.elements.button.focus();
    this.elements.panel.toggleAttribute('hidden');
    this.elements.button.setAttribute(
      'aria-expanded',
      (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
    );
  }

  closeSelector(event) {
    const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
    if (event.relatedTarget === null || shouldClose) {
      this.hidePanel();
    }
  }

  // --- BUTTON TEXT ---
  updateButtonText(label) {
    this.elements.button.innerHTML = `${label} <svg aria-hidden="true" focusable="false" class="icon icon-caret"></svg>`;
  }

  updateButtonTextOnLoad() {
    const saved = localStorage.getItem('selectedCurrency');

    if (saved) {
      // Overrides Liquid value with saved localStorage value
      this.setButtonLabelFromValue(saved);
      return;
    }

    const originalValue = this.elements.input.dataset.originalValue;
    this.setButtonLabelFromValue(originalValue);
  }

  setButtonLabelFromValue(value) {
    if (value === 'INTERNATIONAL') {
      this.updateButtonText('International (USD $)');
    } else if (value === 'US') {
      this.updateButtonText('United States (USD $)');
    } else if (value === 'CA') {
      this.updateButtonText('Canada (CAD $)');
    } else {
      this.updateButtonText('International ');
    }
  }

  // --- ITEM CLICK ---
  onItemClick(event) {
    event.preventDefault();
    const form = this.querySelector('form');
    const value = event.currentTarget.dataset.value;

    let buttonLabel = '';
    let submitValue = value;

    if (value === 'INTERNATIONAL') {
      buttonLabel = 'International (USD $)';
      submitValue = 'US'; // Shopify requires ISO code
    } else if (value === 'US') {
      buttonLabel = 'United States (USD $)';
    } else if (value === 'CA') {
      buttonLabel = 'Canada (CAD $)';
    } else {
      buttonLabel = event.currentTarget.textContent.trim();
    }

    // Update UI
    this.updateButtonText(buttonLabel);
    this.elements.input.value = submitValue;

    // Save selected value
    localStorage.setItem('selectedCurrency', value);

    // Submit the form
    if (form) form.submit();
  }

  // --- LOCAL STORAGE ---
  applySavedCurrency() {
    const savedCurrency = localStorage.getItem('selectedCurrency');
    if (!savedCurrency) return;

    // Override originalValue for correct label on load
    this.elements.input.dataset.originalValue = savedCurrency;
  }

  // --- EARLY APPLY TO PREVENT FLASH ---
  applySavedCurrencyEarly() {
    const savedCurrency = localStorage.getItem('selectedCurrency');
    if (!savedCurrency) return;

    const btn = this.querySelector('button');
    if (!btn) return;

    if (savedCurrency === 'INTERNATIONAL') {
      btn.innerHTML = 'International  <svg aria-hidden="true" focusable="false" class="icon icon-caret"></svg>';
    } else if (savedCurrency === 'US') {
      btn.innerHTML = 'United States (USD $) <svg aria-hidden="true" focusable="false" class="icon icon-caret"></svg>';
    } else if (savedCurrency === 'CA') {
      btn.innerHTML = 'Canada (CAD $) <svg aria-hidden="true" focusable="false" class="icon icon-caret"></svg>';
    }
  }
}

customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }


  }

  customElements.define('sticky-header', StickyHeader);

  $('#shop-btn').click(function(){
   $('body, html').toggleClass('active'); 
});
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);



  
  

  } catch(e) { console.error(e); }
})();
})();
